import { rootContainer } from 'app/shadowRoot';

export function ensureElementVisible(scrollContainer: HTMLElement | null, element: HTMLElement | null) {
  if (!scrollContainer || !element) {
    return;
  }

  rootContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
  const innerRect = scrollContainer.getBoundingClientRect();
  const targetRect = element.getBoundingClientRect();
  const offset = targetRect.top - innerRect.top + scrollContainer.scrollTop;

  scrollContainer.scrollTo({ top: offset, behavior: 'smooth' });
}
